import { createGraph, pieGraphFormatter } from 'graph'


const graphModule = createGraph({
  name: 'graphFleetComposition',
  api: 'dashboard/VehicleFuelDescriptions',
  formatter: pieGraphFormatter,
})

export const actions = graphModule.actions
export const constants = graphModule.constants
export const effects = graphModule.effects
export const reducer = graphModule.reducer

export const useGraphFetch = graphModule.hooks.useGraphFetch
